/* tslint:disable */

import { MSALError } from '../../auth/msal-error';
import { HttpClient } from '../http-client';

export default (client: HttpClient) => {
  client.instance.interceptors.response.use((response) => response, (error) => {
    if (error && error.response && error.response.status === 401) {
      const config = error.response.config;
      const scopes = client.authContext.getScopesForEndpoint(config.url!);

      const tokenStored = client.authContext.getCachedTokenInternal(scopes, client.authContext.getAccount(), '');

      if (tokenStored && tokenStored.accessToken) {
        client.authContext.clearCacheForScope(tokenStored.accessToken);
      }

      const msalError = new MSALError(JSON.stringify(error), "", JSON.stringify(scopes));
      client.authContext.broadcastService.broadcast('msal:notAuthorized', msalError);

      return new Promise((resolve, reject) => {
        client.authContext.acquireTokenSilent({scopes: scopes}).then(token => {
          config.headers["Authorization"] = `Bearer ${token}`;
          client.instance({
            method: config.method,
            url: config.url,
            data: config.data,
            headers: {
              'Accept': config.headers['Accept'],
              'Authorization': config.headers['Authorization'],
              'Content-Type': config.headers['Content-Type']
            }
          }).then(res => resolve(res), err => reject(err))
        });
      });
    } else {
      return Promise.reject(error);
    }
  })
}